(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["shipping-meter"] && !Shopify.designMode) return;
  try {
    class ShippingMeterComponent extends HTMLElement {
    constructor() {
      super();
      this.threshold = 6000;
    }

    connectedCallback() {
      document.addEventListener('cart:update', this.handleCartUpdate.bind(this));
      this.fetchAndUpdate();
    }

    disconnectedCallback() {
      document.removeEventListener('cart:update', this.handleCartUpdate.bind(this));
    }

    handleCartUpdate(event) {
      const cart = event.detail?.resource;
      if (cart && typeof cart.total_price !== 'undefined') {
        this.updateMeter(cart.total_price);
      } else {
        this.fetchAndUpdate();
      }
    }

    async fetchAndUpdate() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        this.updateMeter(cart.total_price);
      } catch (error) {
        console.error('Failed to fetch cart for shipping meter:', error);
      }
    }

    updateMeter(cartTotal) {
      const remaining = this.threshold - cartTotal;
      const progress = Math.min((cartTotal / this.threshold) * 100, 100);
      const isComplete = cartTotal >= this.threshold;
      const remainingDollars = Math.max(0, Math.ceil(remaining / 100));

      const meter = this.querySelector('.shipping-meter');
      const progressBar = this.querySelector('.shipping-meter__progress');
      const textEl = this.querySelector('.shipping-meter__text');
      const iconEl = this.querySelector('.shipping-meter__icon');

      if (progressBar) {
        progressBar.style.width = progress + '%';
      }

      if (meter) {
        if (isComplete) {
          meter.classList.add('shipping-meter--success');
        } else {
          meter.classList.remove('shipping-meter--success');
        }
      }

      if (meter && meter.classList.contains('shipping-meter--full')) {
        if (iconEl) iconEl.textContent = isComplete ? '🎉' : '🚚';
        if (textEl) {
          textEl.innerHTML = isComplete
            ? "You've unlocked <strong>FREE shipping!</strong>"
            : "You're <strong>$" + remainingDollars + "</strong> away from FREE shipping!";
        }
      } else if (meter && meter.classList.contains('shipping-meter--compact')) {
        if (iconEl) iconEl.textContent = isComplete ? '🎉' : '📦';
        if (textEl) {
          textEl.innerHTML = isComplete
            ? "<strong>Free shipping</strong> unlocked!"
            : "<strong>$" + remainingDollars + "</strong> more for free shipping";
        }
      }
    }
  }

  if (!customElements.get('shipping-meter-component')) {
    customElements.define('shipping-meter-component', ShippingMeterComponent);
  }
  } catch(e) { console.error(e); }
})();

})();
